import { createActions, handleActions } from 'redux-actions'
import _ from 'lodash'
import { crudTypes } from '../../util'
import { apiReadWithAuth } from '../../fetchUtils'

export const defaultState = {
  isInitialized:    false,
  lastQuery:           '',
  fetchingCount:        0,
  filteredClassIds:    [],
  filteredCourseIds:   [],
  fetchError:          '',
  isDeletingPrior:       false,
  selectedAssignments: {},
  selectedDate:        '',
  showInfoPanel:    false
}

export const actions = createActions({
  SET_INITIALIZED:          query => ({ query }),
  SET_FILTERS:              (filteredClassIds, filteredCourseIds) => ({ filteredClassIds, filteredCourseIds }),
  BEGIN_FETCH:              ()=>{},
  FETCH_SUCCESS:            ()=>{},
  FETCH_FAILURE:            fetchError =>({ fetchError }),
  BEGIN_DELETE_PRIOR:             ()=>{},
  DELETE_PRIOR_SUCCESS:           ()=>{},
  DELETE_PRIOR_FAILURE:           deletePriorError =>({ deletePriorError }),
  SET_SELECTED_ASSIGNMENTS: selectedAssignments => ({ selectedAssignments }),
  SET_SELECTED_DATE:        selectedDate => ({ selectedDate }),
  CLEAR_SELECTED_ASSIGNMENTS: ()=>{},
  SHOW_INFO_PANEL:          ()=>{},
  HIDE_INFO_PANEL:          ()=>{},
})

const reducer = handleActions(
  {
    [actions.setInitialized]:        (state, { payload: { query } }) => ({ ...state, lastQuery: query, isInitialized: true }),
    [actions.setFilters]:            (state, { payload: { filteredClassIds, filteredCourseIds } }) =>{ return({ ...state, filteredClassIds, filteredCourseIds }) },
    [actions.beginFetch]:            state => ({ ...state, fetchingCount: state.fetchingCount + 1 }),
    [actions.fetchSuccess]:          state => ({ ...state, fetchingCount: state.fetchingCount - 1 }),
    [actions.fetchFailure]:          (state, { payload: { fetchError } }) => ({ ...state, fetchingCount: state.fetchingCount - 1, fetchError }),
    [actions.beginDeletePrior]:           state => ({ ...state, isDeletingPrior: true }),
    [actions.deletePriorSuccess]:         state => ({ ...state, isDeletingPrior: false}),
    [actions.deletePriorFailure]:         (state, { payload: { deletePriorError }}) => ({ ...state, isDeletingPrior: false, deletePriorError}),
    [actions.setSelectedAssignments]: (state, { payload: { selectedAssignments }}) => ({ ...state, selectedAssignments }),
    [actions.setSelectedDate]:       (state, { payload: { selectedDate }}) => ({ ...state, selectedDate }),
    [actions.clearSelectedAssignments]: state => ({...state, selectedAssignments: {}, selectedDate: ''}),
    [actions.showInfoPanel]:         state => ({...state, showInfoPanel: true}),
    [actions.hideInfoPanel]:         state => ({...state, showInfoPanel: false})
  },
  defaultState
)

export function deletePriorAssignments() {
  return dispatch => {
    dispatch(actions.beginDeletePrior())
      return fetch("/assignments/delete_prior",{method: 'DELETE'})
      .then(response => {
        if(response.ok) {
          return response.json()
        } else {
          throw new Error(response.body || response.statusText)
        }
      })
      .then(json => {
        dispatch(actions.deletePriorSuccess())
        //TODO: refetch assignments instead of reloading
        //dispatch(apiReadWithAuth('/assignments', { onSuccess: ()=>{}, onFailure: ()=>{} }))
        window.location.reload(false)
      })
      .catch(error => dispatch(actions.deletePriorFailure(error.message)))
  }
}

export default reducer
